export default "__VITE_ASSET__AD4aYIau__"